module.exports = __webpack_public_path__ + "img/pills.d271c8ad.png";